/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import {Breadcrumb, Modal, notification, Space} from "antd";
import {Link, useHistory} from "react-router-dom";
import {ApiTable} from "../components/table";
import {useAppDispatch, useAppSelector} from "../store";
import {IconSet} from "../components/icons";
import {CustomButton} from "../components/buttons";
import {del, get} from "../core/request";
import {openDrawer} from "../reducers/drawers-reducer";
import {Todo} from "../core/datamodel";

export default function TodoListView(props: any) {
    const person_id = useAppSelector(state => state.auth?.userInfo?.person_id);
    const dispatch = useAppDispatch();

    const history = useHistory();

    const navigateTo = (customer: string | undefined, device: string | undefined) => {
        if (device) {
            history.push(`/devices/${device}`);
        }
        else if (customer) {
            history.push(`/customers/${customer}`);
        }
    }

    return (
        <>
            <Breadcrumb style={{paddingTop: 6, paddingBottom: 6}}>
                <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
                <Breadcrumb.Item> Todos</Breadcrumb.Item>
            </Breadcrumb>

            <ApiTable
                title={<><IconSet type='note'/> Todos</>}
                id="Todos"
                url="todos"
                url_params={"person=" + person_id}
                reloadSignals={[useAppSelector(state => state.reloadSignals.todo)]}
                searchable
                actions={(text: any, record: any) =>
                        <div style={{display: "inline-flex", position: "absolute", left: 5, top: 4}}>
                            <CustomButton
                            mode={'delete'}
                            noBorder
                            onClick={() => Modal.confirm({
                                title: "Aufgabe überspringen",
                                content: "Sollen diese Aufgabe wirklich übersprungen werden? Das bearbeiten der Aufgabe löst diesen Eintrag automatisch.",
                                maskClosable: true,
                                cancelText: 'Abbrechen',
                                okText: 'Überspringen',
                                okType: 'danger',
                                autoFocusButton: 'cancel',
                                onOk: () => {
                                    del("todos/" + record.key).catch((error) => {
                                        notification.error({
                                            message: "Fehlende Berechtigungen",
                                            description: "Todo konnte nicht als erledigt markiert werden.",
                                            duration: 30,
                                        })
                                    })
                                }
                            })
                            }
                            tooltip={"Aufgabe überspringen"}
                            />

                            { (record.gerät !== "" || record.kunde !== "") ? (
                            <CustomButton
                                mode={"visible"}
                                noBorder
                                className={"button-edit"}
                                onClick={() => {
                                    get("todos/" + record.key).done((response) => {
                                        navigateTo(response.data.todo.customer?.uuid, response.data.todo.device?.uuid)
                                    })
                                }}
                            />
                            ) : (
                                <div style={{width: "2rem", height: "1rem"}} />
                            )}

                            {record.is_editable ? (
                                <CustomButton
                                    mode={'edit'}
                                    noBorder
                                    onClick={() => {
                                        get("todos/" + record.key).done((response) => {
                                            dispatch(openDrawer({key: 'todo', object: new Todo(response.data.todo)}))
                                        })

                                    }}
                                    tooltip={"Aufgabe bearbeiten"}
                                />
                            ) : (
                                <div style={{width: "2rem", height: "1rem"}} />
                            )
                            }

                        </div>
                    }
                actionWidth={100}
                buttons={
                    <CustomButton
                        mode={'add'}
                        tooltip={"Neues Todo hinzufügen"}
                        onClick={() => dispatch(openDrawer({key: 'todo', object: new Todo({})}))}
                    />
                }
            />
        </>
    )
}